(ns motorsaif.shared.interceptors
  (:require
   [re-frame.core :as rf]
   [motorsaif.string :refer [format]]
   [motorsaif.log :as log]
   [motorsaif.time :as time]))

(def require-user
  (rf/->interceptor
   :id     :require-user
   :after  (fn [{:keys [coeffects] :as context}]
             (let [{:keys [db]} coeffects
                   user-id (get-in db [:user :db/id])]
               (if user-id
                 context
                 (assoc context :effects {}))))))

(def prevent-duplicate-requests
  (rf/->interceptor
   :id :prevent-duplicate-requests
   :after (fn [{:keys [coeffects effects] :as context}]
             (let [{:keys [db original-event]}      coeffects
                   ajax-id                          (get-in effects [:ajax :id])
                   {:keys [error fetching fetched]
                    :as status} (get-in db [:ajax-status ajax-id])]


               context
               #_(if (and fetching
                        (nil? error)
                        (nil? fetched))
                 (do
                   (log/info [:skip-ajax ajax-id :status status])
                   (-> context
                       (update :effects dissoc :ajax)
                       (update :queue (fn [queue] (vec (filter #(not= (:id %) :trace-fetch-status) queue))))))
                 (do
                   (log/info [:ok-ajax :ajax-id])
                   context))
               #_(if (and fetching
                          (nil? error)
                          (nil? fetched))
                   (-> context
                       (update :effects dissoc :ajax)
                       (update :queue (fn [queue] (vec (filter #(not= (:id %) :trace-fetch-status) queue)))))
                   context)))))


(def trace-fetch-status
  (rf/->interceptor
   :id     :trace-fetch-status
   :after  (fn [{:keys [coeffects effects] :as context}]
             ;; Assoc the event in the db
             ;; put under [:ajax-status `ajax-id`]
             ;; map:
             ;; {:fetching `timestamp`
             ;;  :fetched `ts`
             ;;  :original-event `original-event` ; for retry code later
             ;;  :last-fetch #{:success error}
             ;; }

             (assert (get-in effects [:ajax :id])
                     (format "Must have ajax ID, from %s"
                             (str (:event coeffects))))

             (let [{:keys [db _original-event]} coeffects
                   ajax-id (get-in effects [:ajax :id])
                   ajax-status (-> (get db :ajax-status)
                                   (assoc-in [ajax-id :fetching] (time/stamp))
                                   (update-in [ajax-id] dissoc :fetched :error))

                   latest-db (if (:db effects)
                               :effects ; db intended to be modified
                               :coeffects ; no new info for db, so use current state
                               )
                   new-db (assoc (get-in context [latest-db :db]) :ajax-status ajax-status)

                   new-ctx (assoc-in context [:effects :db] new-db)]
               (log/debug [:id ajax-id
                          :ajax ajax-status])
               new-ctx))))
